module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('strong', [_vm._v("Account Information")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "First Name",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.user.first_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "first_name", $$v)
      },
      expression: "user.first_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Last Name",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.user.last_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "last_name", $$v)
      },
      expression: "user.last_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Company"
    },
    model: {
      value: (_vm.user.company_name),
      callback: function($$v) {
        _vm.$set(_vm.user, "company_name", $$v)
      },
      expression: "user.company_name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Email Address",
      "type": "email",
      "rules": [_vm.rules.email]
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Change Password")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "New Password",
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Confirm Password",
      "type": "password",
      "rules": [_vm.rules.passwordMustMatch]
    },
    model: {
      value: (_vm.confirm_password),
      callback: function($$v) {
        _vm.confirm_password = $$v
      },
      expression: "confirm_password"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveUser()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b48d423e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/login-info.vue
// module id = 679
// module chunks = 1